import { css } from 'styled-components';

export const styleFont = {
  displayLarge: css`
    /* display-large */
    font-family: Pretendard;
    font-size: 58px;
    font-style: normal;
    font-weight: 700;
    line-height: 64px; /* 110.345% */
  `,
  displayMedium: css`
    /* display-medium */
    font-family: Pretendard;
    font-size: 44px;
    font-style: normal;
    font-weight: 700;
    line-height: 52px; /* 118.182% */
  `,
  displaySmall: css`
    /* display-small */
    font-family: Pretendard;
    font-size: 36px;
    font-style: normal;
    font-weight: 700;
    line-height: 44px; /* 122.222% */
  `,
  headlineLarge: css`
    /* headline-large */
    font-family: Pretendard;
    font-size: 32px;
    font-style: normal;
    font-weight: 700;
    line-height: 40px; /* 125% */
  `,
  headlineMedium: css`
    /* headline-medium */
    font-family: Pretendard;
    font-size: 28px;
    font-style: normal;
    font-weight: 700;
    line-height: 36px; /* 128.571% */
  `,
  headlineSmall: css`
    /* headline-small */
    font-family: Pretendard;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: 32px; /* 133.333% */
  `,
  titleLarge: css`
    /* title-large */
    font-family: Pretendard;
    font-size: 22px;
    font-style: normal;
    font-weight: 700;
    line-height: 28px; /* 127.273% */
  `,
  titleMedium: css`
    /* title-medium */
    font-family: Pretendard;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px; /* 133.333% */
  `,
  titleSmall: css`
    /* title-small */
    font-family: Pretendard;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px; /* 142.857% */
  `,
  labelLarge: css`
    /* label-large */
    font-family: Pretendard;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px; /* 150% */
  `,
  labelMedium: css`
    /* label-medium */
    font-family: Pretendard;
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: 16px; /* 133.333% */
  `,
  labelSmall: css`
    /* label-small */
    font-family: Pretendard;
    font-size: 11px;
    font-style: normal;
    font-weight: 600;
    line-height: 16px; /* 145.455% */
  `,
  bodyLarge: css`
    /* body-large */
    font-family: Pretendard;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px; /* 150% */
  `,
  bodyMedium: css`
    /* body-medium */
    font-family: Pretendard;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 142.857% */
  `,
  bodySmall: css`
    /* body-small */
    font-family: Pretendard;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px; /* 133.333% */
  `,
  buttonLarge: css`
    /* button-large */
    font-family: Pretendard;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px; /* 133.333% */
  `,
  buttonMedium: css`
    /* button-medium */
    font-family: Pretendard;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px; /* 150% */
  `,
  buttonSmall: css`
    /* button-small */
    font-family: Pretendard;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 16px; /* 114.286% */
  `
};
